<template>
  <div>
    <!--搜索栏-->
    <searchBar
      :search-form="searchForm"
      :workTypeList="typeList"
      name
      workTypeId
      status
      @handleSearch="getData"
      btn-add
      @handleAdd="handleAdd"
    ></searchBar>

    <!--表格-->
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>
      <el-table-column fixed="right" label="办理条件" align="center">
        <template slot-scope="scope">
          <el-popover placement="left" width="400" trigger="hover">
            <div
              v-if="!!scope.row.conditions"
              v-html="scope.row.conditions"
            ></div>
            <div v-if="!scope.row.conditions">无内容</div>
            <el-button slot="reference" type="text">查看</el-button>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="所需材料" align="center">
        <template slot-scope="scope">
          <el-button
            @click="showDialogContent(scope.row.material)"
            type="text"
            size="mini"
          >
            点击查看
          </el-button>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button
            @click="handleSequence(scope.row, 1)"
            type="text"
            :disabled="scope.$index === 0 && page == 1"
            class="text-gray"
            size="mini"
          >
            上移
          </el-button>
          <el-button
            @click="handleSequence(scope.row, 2)"
            type="text"
            :disabled="
              scope.$index === currentElements - 1 && page == totalPages
            "
            size="mini"
          >
            下移
          </el-button>
          <el-button @click="handleEdit(scope.row)" type="text" size="mini">
            编辑
          </el-button>
          <el-button
            @click="handleEnabled(scope.row)"
            type="text"
            :style="{ color: scope.row.status === 1 ? 'red' : '' }"
            size="mini"
          >
            {{ scope.row.status === 1 ? "禁用" : "启用" }}
          </el-button>
          <el-button
            @click="handleDelete(scope.row)"
            type="text"
            style="color:red"
            size="mini"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>

    <!--新增Dialog-->
    <el-dialog
      title="添加/修改办事指南"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
      >
        <el-form-item label="名称" prop="name" label-width="100px">
          <el-input
            v-model="form.name"
            size="medium"
            placeholder="名称"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="类型"
          style="text-align: left"
          prop="type"
          label-width="100px"
        >
          <el-select
            v-model="form.type"
            placeholder="选择类型"
            style="width: 200px;"
            clearable
          >
            <el-option
              :label="item.name"
              v-for="(item, index) in typeList"
              :key="index"
              :value="item.uid"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="办理条件"
          v-if="dialogFormVisible"
          label-width="100px"
          prop="conditions"
        >
          <richtext-editor
            :editor-content="form.conditions"
            @textChange="updateContent"
          />
        </el-form-item>

        <el-form-item label="需要材料" prop="needMaterial" label-width="100px">
          <div style="text-align: left">
            <el-radio
              v-model="form.needMaterial"
              :label="true"
              @input="hasMater"
            >
              需要
            </el-radio>
            <el-radio
              v-model="form.needMaterial"
              :label="false"
              @input="hasMater"
            >
              不需要
            </el-radio>
          </div>
        </el-form-item>

        <el-form-item
          label="预审材料"
          v-if="form.needMaterial"
          prop="material"
          label-width="100px"
        >
          <richtext-editor
            :editor-content="form.material"
            @textChange="updateMaterial"
          />
        </el-form-item>

        <el-form-item label="办理地点" prop="dealPlace" label-width="100px">
          <el-input
            v-model="form.dealPlace"
            size="medium"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>

        <!--				<el-form-item label="位置选取"
                              label-width="100px">
                  <el-input v-model="keyword"
                            size="medium"
                            placeholder="检索位置后需手动放置定位点"
                  ></el-input>
                  <baidu-map class="bm-view"
                             :center="center"
                             :scroll-wheel-zoom="true"
                             @click="mapClick"
                             @ready="handler">
                    <bm-local-search :keyword="keyword"
                                     :forceLocal="true"
                                     :pageCapacity="2"
                                     :auto-viewport="true"
                    ></bm-local-search>
                    <bm-marker :position="center"
                               :dragging="true">
                    </bm-marker>
                    <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                                    :showAddressBar="true"
                                    :autoLocation="true">
                    </bm-geolocation>


                  </baidu-map>
                </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>

    <el-dialog
      title="所需材料"
      :close-on-click-modal="false"
      :visible.sync="dialogContentVisible"
    >
      <div
        v-if="!!dialogContent"
        style="text-align: left"
        v-html="dialogContent"
      ></div>
      <div v-if="!dialogContent">无内容</div>
    </el-dialog>
  </div>
</template>

<script>
import { downloadFile } from "@/assets/http/utils"
import Axios from "axios"
import apiUrl from "@/assets/http/apiUrl"
import richtextEditor from "@/components/richtextEditor/richtextEditor"

export default {
  name: "workGuide",
  components: {
    richtextEditor,
  },
  data() {
    let Self = this

    // 表单验证
    let validate = (rule, value, callback) => {
      if (!!value) {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("数据填写不完整"))
      }
    }

    return {
      // 页面初始数据
      totalElements: 10,
      currentElements: 10,
      totalPages: 1,
      size: 10,
      page: 1,

      serverUrl: apiUrl.ServerUrl,

      // 搜索栏初始化
      searchForm: {
        name: "",
        workTypeId: "",
        gender: "",
        idCard: "",
        mobile: "",
        family: "",
        street: "",
        education: "",
      },

      // 表头初始化
      tableHeader: {
        name: "名称",
        dealPlace: "办理地点",
        typeName: "办事类型",
      },

      // 表格数据
      tableData: [],

      // dialog可见性
      dialogFormVisible: false,
      dialogUploadVisible: false,
      dialogContentVisible: false,
      dialogContent: "",

      // 上传文件列表
      file: "",

      // icon列表
      iconList: [],

      // 新增表单
      form: {
        uid: "",
        name: "", //名称
        type: "", //类型
        conditions: "", //办理条件
        dealPlace: "", //办理地点
        needMaterial: false, //是否需要材料
        material: "",
      },

      // 表单验证规则
      rules: {
        type: {
          required: true,
          message: "请选择办事类型",

          trigger: "blur",
        },
        name: {
          required: true,
          validator: validate,
          trigger: "blur",
        },
        conditions: {
          required: true,

          validator: validate,
          trigger: "blur",
        },
        dealPlace: {
          required: true,

          validator: validate,
          trigger: "blur",
        },
        needMaterial: {
          required: true,
          message: "填写数据不完整",
          trigger: "blur",
        },
        material: {
          required: true,
          message: "请填写所需要的材料",
          trigger: "blur",
        },
      },

      // 头像上传初始化
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,

      // 编辑器配置
      editorOption: {
        placeholder: "请输入",
        modules: {
          toolbar: {
            container: [
              "bold",
              "italic",
              "underline",
              "strike",
              "align",
              "link",
              "image",
            ],
            handlers: {
              image: function() {
                QuillWatch.emit(this.quill.id)
              },
            },
          },
          ImageExtend: {
            // 如果不作设置，即{}  则依然开启复制粘贴功能且以base64插入
            name: "file", // 图片参数名
            size: 3, // 可选参数 图片大小，单位为M，1M = 1024kb
            action: apiUrl.server + "/manager/upload/uploadPic", // 服务器地址, 如果action为空，则采用base64插入图片
            response: res => {
              return apiUrl.server.replace("/api", "") + res.data
            },
            headers: xhr => {
              // xhr.setRequestHeader('myHeader','myValue')
            }, // 可选参数 设置请求头部
            sizeError: () => {}, // 图片超过大小的回调
            start: () => {}, // 可选参数 自定义开始上传触发事件
            end: () => {}, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
            error: () => {}, // 可选参数 上传失败触发的事件
            success: () => {}, // 可选参数  上传成功触发的事件
            change: (xhr, formData) => {
              // xhr.setRequestHeader('myHeader','myValue')
              // formData.append('token', 'myToken')
            }, // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
          },
        },
      },

      // 办事类型
      typeList: [],

      // 地图配置
      center: "成都市",
      addressKeyword: "",
      geolocation: {},
      keyword: "",
    }
  },

  methods: {
    /*地图相关处理
     * */

    mapClick(e) {
      this.center = {
        lng: e.point.lng,
        lat: e.point.lat,
      }
    },

    handler({ BMap, map }) {
      this.center = {
        lng: map.re.lng,
        lat: map.re.lat,
      }
      this.form.latitude = map.re.lng
      this.form.longitude = map.re.lat
    },

    /*图片预览*/
    getImgPreviewList(url) {
      let arr = new Array(this.serverUrl + url)
      return arr
    },

    /*请求数据
     * */
    getData() {
      this.request({
        url: "/manager/workGuide/findGuide",
        method: "get",
        params: {
          page: this.page,
          size: this.size,
          type: this.searchForm.workTypeId,
          name: this.searchForm.name,
          property: "sequence",
          direction: "asc",

          name: this.searchForm.name,
          mobile: this.searchForm.mobile,
          status: this.searchForm.status,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages
          this.currentElements = res.data.data.currentElements

          this.tableData = res.data.data.content ?? []
          this.tableData.forEach(item => {
            item.conditions = item.conditions.replace(
              /\<img/gi,
              '<img style="width:100%"'
            )
          })
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    // 办事类型
    getType() {
      this.request({
        url: "/manager/workGuide/getGuideTypeList",
        method: "get",
      })
        .then(res => {
          this.typeList = res.data.data
          // this.$message.success("操作成功")
          // this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*更改单页数据数量
     * */
    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    /*页码跳转
     * */
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },

    /*启用/禁用
     * */
    handleEnabled(rowData) {
      let status = rowData.status === 1 ? 2 : 1
      this.request({
        url: "/manager/workGuide/updateStatus",
        data: {
          uid: rowData.uid,
          status: status,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    hasMater(e) {
      console.log(e)
      if (e) {
      } else {
        this.$refs.form.clearValidate("needMaterial")
      }
    },

    /*编辑
     * */
    handleEdit(rowData) {
      this.request({
        url: "/manager/workGuide/getIcons",
      })
        .then(res => {
          if (res.data.status === "BAD_REQUEST") {
            this.$message.warning(res.data.message)
          }
          this.iconList = res.data.data
        })
        .catch(err => {})

      this.form = {
        ...rowData,
      }
      this.form.icon = rowData.iconUid

      this.dialogFormVisible = true
      this.center = {
        lng: this.form.longitude,
        lat: this.form.latitude,
      }
    },

    /*更改排序
     * 上移 1
     * 下移 2*/
    handleSequence(rowData, type) {
      this.request({
        url: "/manager/workGuide/changeSequence",
        data: {
          uid: rowData.uid,
          type: type,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*服务类型
     * */
    handleAdd() {
      this.form = {}
      this.request({
        url: "/manager/workGuide/getIcons",
      })
        .then(res => {
          if (res.data.status === "BAD_REQUEST") {
            this.$message.warning(res.data.message)
          }
          this.iconList = res.data.data
        })
        .catch(err => {})

      this.dialogFormVisible = true
    },

    /*删除
     * */
    handleDelete(rowData) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/workGuide/deleteGuide",
            params: {
              uid: rowData.uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },

    /*dialog提交
     * */
    dialogConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.dialogFormVisible = false

          this.request({
            url: "/manager/workGuide/addOrUpdateGuide",
            data: {
              uid: this.form.uid,
              name: this.form.name,
              type: this.form.type,
              conditions: this.form.conditions,
              material: this.form.material,
              dealPlace: this.form.dealPlace,
              needMaterial: this.form.needMaterial,
            },
            method: "post",
          })
            .then(res => {
              if (res.data.status === "BAD_REQUEST") {
                this.$message.warning(res.data.message)
              }

              this.getData()
              this.form = {}
              this.form.needMaterial = false
            })
            .catch(err => {})
        }
      })
    },

    /*dialog取消
     * */
    dialogCancel() {
      this.form = {}
      this.center = {}
      this.dialogFormVisible = false
    },

    /*覆盖默认上传请求
     * */
    overwriteDefault(e) {
      let tmpFile = new FormData()
      tmpFile.append("file", e.file)
      this.file = tmpFile
      Axios.post(apiUrl.server + "/manager/upload/uploadAvatar", this.file, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
        .then(res => {
          if (res.data.status === "OK") {
            this.$message.success("上传成功")
            this.form.avatar = res.data.data
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    uploadCancel() {
      this.dialogUploadVisible = false
      this.form = {}
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    updateContent(e) {
      this.form.conditions = e
    },
    updateMaterial(e) {
      this.form.material = e
    },
    showDialogContent(content) {
      this.dialogContentVisible = true
      this.dialogContent = content
    },
    /*地图初始化
     * */
  },
  mounted() {
    this.getData()
    this.getType()
  },
  beforeDestroy() {
    this.editor = null
    delete this.editor
  },
}
</script>

<style scoped>
.bm-view {
  width: 100%;
  height: 300px;
}
</style>
